// Public URLs the web app links to. APP_STORE_URL stays empty until App
// Review approves the iPhone app; set it to the app's apps.apple.com link
// then (landing/index.html has the same constant).
export const APP_STORE_URL = "";
export const LANDING_URL = "https://followtheleader.app";
export const TERMS_URL = "https://followtheleader.app/eula.html";
export const PRIVACY_URL = "https://followtheleader.app/privacy.html";
